<template>
  <div class="col-sm-6">
    <h3 class="heading_h4 mb_16">
      Email Preview
    </h3>
    <div class="card preview-container">
      <div class="preview-header">
        <div class="header-subject">
          <h1>{{ preview_subject }}</h1>
          <button
            class="btn btn-primary"
            type="button"
            @click="sendTestEmail"
          >
            Send test email
          </button>
        </div>
        <div class="header-fromto">
          <div>
            <b>From:</b> {{ from.name }} &lt;{{ from.email }}&gt;
          </div>
          <div>
            <b>To:</b> {{ to.name }} &lt;{{ to.email }}&gt;
          </div>
        </div>

        <hr style="width:100%;">
      </div>

      <div class="mail-body">
        <div class="mail-logo">
          <img
            v-if="whitelabel.logo"
            :src="`https://s3.eu-west-2.amazonaws.com/seo-public/${whitelabel.logo}`"
          >
        </div>

        <div class="mail-content">
          <div v-html="preview_body" />
          <div
            v-if="template.sub_component"
            class="component-placeholder"
          >
            Template Sub Component will load here.
          </div>
        </div>

        <div class="mail-support">
          Contact <a href="mailto:{{from.email}}">{{ from.email }}</a> if you have any questions about this email.
          You can manage your notifications within your account settings.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    content: {
      type: Object,
      default: null,
    },
    template: {
      type: Object,
      default: null,
    },
    from: {
      type: Object,
      default: null,
    },
    to: {
      type: Object,
      default: null,
    },
    emailComponent: {
      type: Object,
      default: null,
    },
    emailComponentVariables: {
      type: Object,
      default: null,
    },
    defaultVariables: {
      type: Object,
      default: null,
    },
    dummyVariables: {
      type: Object,
      default: null,
    },
    whitelabel: {
      type: Object,
      default: null,
    }
  },
  emits: ['selectedComponent'],
  data() {
    return {
      preview_body: "",
      preview_subject: "",
    }
  },
  watch: {
    'content.body'(new_value) {
      this.applyVariables(new_value);
    },
    'content.subject'(new_value) {
      this.applyVariables(new_value, true);
    }
  },
  mounted() {
    this.applyVariables(this.content?.body);

    this.applyVariables(this.content?.subject, true);
  },
  methods: {
    async sendTestEmail() {
      await axios.post('/ajax/mail/test', this.content)
          .then(data => {
            this.$notify(data.data.message);
          })
          .catch(err => {
            console.error(err);
            this.$notify({
              text: err.message,
              type: 'error',
            });
          })
    },
    applyVariables(raw_content, is_subject = false) {
      let content = raw_content;
      this.$emit('selectedComponent');

      if (content.length > 0) {
        // Swap components first to prevent name change in general variable search.
        if (this.emailComponent && !is_subject) {
          let active_components = [];
          this.emailComponent.forEach(component => {
            // Create temp variable to remove square brackets
            let temp_variable = component.variable_name;

            const found_variables = content.match(/(\[\[[A-Z])\w+\]\]/g);
            found_variables.forEach(variable => {
              if (variable === `[[${temp_variable}]]`) {
                active_components.push(component.id);
              }
            });

            // place dummy content
            const dummy_data = this.emailComponentVariables[component.variable_name];

            content = content.replace(`[[${temp_variable}]]`, dummy_data);
          });

          this.$emit('selectedComponent', active_components);
        }

        // Find all variables starting with [[ and ending with ]]
        const found_variables = content.match(/(\[\[[A-Z])\w+\]\]/g);

        // Loop through all found variables and replace with generic string
        if (found_variables && found_variables.length > 0) {
          found_variables.forEach(variable => {
            // Create temp variable to remove square brackets
            let temp_variable = variable;
            temp_variable = temp_variable.replace("[[", "");
            temp_variable = temp_variable.replace("]]", "");

            let default_variable = null;

            // If no default variable try dummy variable
            const dummy_variable = this.dummyVariables[`${temp_variable}`] ? this.dummyVariables[`${temp_variable}`] : null;

            if (dummy_variable) {
              temp_variable = dummy_variable;
            }

            // Find default variable value
            default_variable = this.defaultVariables[`${temp_variable}`] ? this.defaultVariables[`${temp_variable}`] : null;

            if (!default_variable) {
              default_variable = temp_variable ? temp_variable : "example data";
            }

            // Replace original variable with found default
            content = content.replace(variable, default_variable);
          });
        }

      }

      if (is_subject) {
        this.preview_subject = content;
      } else {
        this.preview_body = content;
      }
    }
  }
}
</script>

<style scoped>
.preview-container {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.preview-header {
  display: inherit;
  flex-direction: column;
}

.header-subject {
  display: flex;
  justify-content: space-between;;
}

.header-subject h1 {
  max-width: 66%;
}

.header-subject button {
  max-height: 40px;
}

.header-fromto {
  display: inherit;
  flex-direction: column;
}

.mail-body {
  background-color: #F5F5F5;
  padding: 1rem 3rem 3rem 3rem;
}

:deep(.mail-body p),
.mail-support {
  font-family: Verdana, Geneva, sans-serif !important;
}

.mail-logo {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.mail-logo img {
  width: auto;
  height: auto;
  max-width: 256px;
  max-height: 128px;
}

.mail-content {
  background-color: white;
  padding: 3rem;
  border: 1px solid #E6E6E6;
  border-radius: 5px;
}

.mail-support {
  color: black;
  text-align: center;
  font-size: 10pt;
  padding: 1rem 3rem;
  line-height: normal;
}

.mail-support a {
  color: #FB7E7A;
}

.component-placeholder {
  text-align: center;
  font-weight: bold;
  background: #FB7E7A;
  border-radius: 3px;
  color: white;
  padding: 1rem;
}

.heading_h4 {
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
  font-weight: 700;
}

@media screen and (max-width: 1200px) {
  .heading_h4 {
    font-size: 1.25rem;
  }
}
</style>
